<template>
  <div class="exam_contain">
    <div class="exam_select_flex">
      <div class="exam_select_box">
        <div class="exam_select_item" style="width:291px">
          <span>考生信息：</span>
          <el-input v-model="keyword" placeholder="可搜索姓名或手机号码"></el-input>
        </div>
        <div class="exam_select_item">
          <span>批次：</span>
          <el-select v-model="appraisalId" placeholder="请选择批次">
            <el-option
              v-for="(item,index) in batchList"
              :key="index"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="exam_select_item">
          <span>科目：</span>
          <el-select v-model="subject" placeholder="请选择科目">
            <el-option
              v-for="(item,index) in subjectItem"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="exam_select_box">
        <div class="exam_select_item" style="margin-left:30px">
          <span>状态：</span>
          <el-select v-model="status" placeholder="请选择状态">
            <el-option
              v-for="(item,index) in statusItem"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="exam_button_box">
      <el-button type="primary" @click="getPageList()">查询</el-button>
      <el-button type="primary" @click="submit(multipleSelection)">确认提交</el-button>
      <el-button type="primary" @click="appointment(multipleSelection)">预约缴费</el-button>
      <el-button type="primary" @click="deleteItem(multipleSelection)">删除</el-button>
      <el-button type="primary" @click="getExport(multipleSelection)">导出</el-button>
    </div>
    <!-- 表格 -->
    <div class="table_wrapper">
      <div class="table_content">
        <el-table 
          border 
          :data="examarr" 
          max-height="650"
          @selection-change="handleSelectionChange"
          :row-key="getRowKeys"
          :cell-style="cellStyle"
          stripe
        >
          <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
          <el-table-column prop="serial" width="70" label="序号"></el-table-column>
          <el-table-column prop="examName" label="姓名"></el-table-column>
          <el-table-column prop="examPhone" label="手机号"></el-table-column>
          <el-table-column prop="examSubiectName" label="工种"></el-table-column>
          <el-table-column prop="examRank" label="等级"></el-table-column>
          <el-table-column prop="subject" label="科目"></el-table-column>
          <el-table-column prop="statusText" label="状态"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <div class="table_content_operation">
                <!-- 编辑考生信息 -->
                <el-tooltip class="item" effect="dark" content="编辑修改" placement="bottom">
                  <img 
                    v-if="scope.row.statusText==='机构确认中' || scope.row.statusText==='评价方驳回'"
                    class="operation_img" 
                    @click="studentInfoReview(scope.row.id)" 
                    src="@/assets/image/batchSignUp/icon_edit.png" />
                </el-tooltip>
                <!-- 查看驳回原因-->
                <el-tooltip class="item" effect="dark" content="查看驳回原因" placement="bottom">
                  <img 
                    v-if="scope.row.statusText==='评价方驳回'||scope.row.statusText==='支付已驳回'"  
                    class="operation_img"
                    @click="gotoReject(scope.row.id)" 
                    src="@/assets/image/batchSignUp/icon_check.png"/>
                </el-tooltip>
                <!-- 查看考生信息 -->
                <el-tooltip class="item" effect="dark" content="查看报考信息" placement="bottom">
                  <img 
                    v-if="scope.row.statusText==='评价方审核中' || scope.row.statusText==='待预约' || scope.row.statusText==='支付审核中' || scope.row.statusText==='待支付'"
                    class="operation_img" 
                    @click="studentInfoPreview(scope.row.id)" 
                    src="@/assets/image/batchSignUp/icon_check.png"/>
                </el-tooltip>
                <!-- 删除 -->
                <el-tooltip class="item" effect="dark" content="删除报考信息" placement="bottom">
                  <img 
                    v-if="scope.row.statusText==='机构确认中' || scope.row.statusText === '评价方驳回'"
                    class="operation_img" 
                    @click="deleteItem(scope.row.id)" 
                    src="@/assets/image/batchSignUp/icon_delete.png"/>
                </el-tooltip>
                <!-- 提交到协会审核 -->
                <el-tooltip class="item" effect="dark" content="确认提交" placement="bottom">
                  <img 
                    v-if="scope.row.statusText === '机构确认中' || scope.row.statusText === '评价方驳回'"
                    class="operation_img" 
                    @click="submit(scope.row.id)" 
                    src="@/assets/image/batchSignUp/icon_submit.png"/>
                </el-tooltip>    
                <!-- 前往支付 -->
                <el-tooltip class="item" effect="dark" content="前往支付" placement="bottom">
                  <img 
                    v-if="scope.row.statusText==='待支付'||scope.row.statusText==='支付已驳回'"
                    class="operation_img" 
                    @click="gotoOrderDetail(scope.row)" 
                    src="@/assets/image/batchSignUp/icon_pay.png"/>
                </el-tooltip>
                <!-- 预约 -->
                <el-tooltip class="item" effect="dark" content="预约缴费" placement="bottom">
                  <img 
                    v-if="scope.row.statusText === '待预约'"
                    class="operation_img" 
                    @click="appointment(scope.row.id)" 
                    src="@/assets/image/batchSignUp/icon_appointment.png"/>
                </el-tooltip>    
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="page_footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[12, 24, 48, 360]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="listCount">
      </el-pagination>
    </div>
    <van-dialog   class="writeboxbox" v-model="showreject" title="驳回原因" @confirm="submitreject()"   @cancel="submitnopay" show-cancel-button message="1.身份复印件格式错误，2.社保记录年限"
    confirmButtonText="前往修改" confirmButtonColor="#54B0FB" cancelButtonText="关闭">
    </van-dialog>
    <van-dialog v-model="showdailog" title="提示" @confirm="submitispay" @cancel="submitnopay" show-cancel-button>
      <span>确定要预约缴费吗</span>
    </van-dialog>
  </div>
</template>

<script>
import { Dialog } from 'vant';
import {downloadBlob} from '@/utils/util.js'
export default {
  data() {
    return {
      multipleSelection: [],  //选中的数据
      subjectItem: [
        { name: '全部科目', value: '' },
        { name: '理论', value: '理论' },
        { name: '实操', value: '实操' },
        { name: '理论，实操', value: '理论，实操' },
      ],
      statusItem: [
        { name: '全部状态', value: '' },
        { name: '机构确认中', value: 'unConfirm' },
        { name: '评价方审核中', value: 'beingReviewed' },
        { name: '待预约', value: 'unAppointment' },
        { name: '待支付', value: 'unPay' },
        { name: '评价方驳回', value: 'rejected' },
        { name: '支付审核中', value: 'payAuditing' },
        { name: '支付已驳回', value: 'payRejected' }
      ],
      subject: '', 
      status: '',
      statusObj:{
        'unConfirm': '机构确认中',
        'beingReviewed': '评价方审核中',
        'unAppointment': '待预约',
        'unPay': '待支付',
        'rejected': '评价方驳回',
        'payAuditing': '支付审核中',
        'payRejected': '支付已驳回'
      },
      batchList: [{'name': '全部批次', 'id': ''}],
      showdailog: false,
      showreject: false,
      examarr: [],
      examId: '',
      listCount: 0,
      page: 1,
      keyword: '',
      limit: 12,
      appraisalId: ''
    }
  },
  created() {
    this.getBatchList()
  },
  watch: {
    // 考生信息
    keyword: function(){
      this.page = 1
      this.getPageList()
    },
    //批次
    appraisalId: function() {
      this.page = 1
      this.getPageList()
    },
    // 科目
    subject: function() {
      this.page = 1
      this.getPageList()
    },
    // 状态
    status: function() {
      this.page = 1
      this.getPageList()
    }
  },
  computed: {
    pageCount: function() {
      return this.listCount % this.limit === 0 ? parseInt(this.listCount / this.limit) : parseInt(this.listCount / this.limit) + 1
    }
  },
  methods: {
    getBatchList: function() { //查询现有批次信息
      this.$http.get('/examination/batch/list').then(res => {
        if(res.data.success){
          this.batchList = this.batchList.concat(res.data.data)
          this.appraisalId = this.batchList.find(element => element.occupationLevelCode === 'sk-003' ).id
          this.getPageList()
        }
      })
    },
    getPageList(){ //获取列表数据
      let params = {
        subject: this.subject,
        status: this.status,
        keyword: this.keyword,
        limit: this.limit,
        page: this.page,
        appraisalId: this.appraisalId
      }
      this.$http.get(`/registration/condition`, { params }).then((res) => {
        if (res.data.success && res.status == 200) {
          this.listCount = res.data.data.count 
          let list = res.data.data.resultList || []
          if(res.data.data.resultList){
            list.forEach((element,index) => {
              element.serial = (this.page - 1 ) * params.limit + ( index + 1)
              element.statusText = this.statusObj[element.status]
            })
          }
          this.examarr = list
        }
      })
    },
    //预约缴费
    appointment(id) {
      if(Array.isArray(id) || !id.length){
        if (id.some(item => item.statusText !== '待预约')) {
          this.$message({
            message: "请选择状态为待预约的考生预约交费",
            type: "error",
          })
          return;
        } else if (!id.length) {
          this.$message({
            message: "请最少选择一项",
            type: "error",
          })
          return;
        }
      }
      this.$dialog.confirm({
        title: '提示',
        message: '确定预约交费吗？',
        confirmButtonColor: '#54B0FB',
        confirmButtonText:'确定',
      }).then(() => {
        let ids = ''
        if(Array.isArray(id)){
          ids = id.map(element => element.id).join(',')
        }else {
          ids = id
        }
        this.$router.push({
          path: "/batchSignUp/appointment/edit",
          query: { ids:ids }
        })
      })
    },
    submit(id) {
      if(Array.isArray(id) || !id.length){
        if (id.every(item => item.statusText !== '机构确认中' && item.statusText !== '评价方驳回' )) {
          this.$message({
            message: "请选择状态为机构确认中或评价方驳回的考生提交到评价方审核",
            type: "error",
          })
          return;
        } else if (!id.length) {
          this.$message({
            message: "请最少选择一项",
            type: "error",
          })
          return;
        }
      }
      this.$dialog.confirm({
        title:'提示',
        confirmButtonText:'确定',
        message:'确定要提交到评价方吗？',
        confirmButtonColor:'#54B0FB'
      }).then(()=>{
        let ids = ''
        if(Array.isArray(id)){
          ids = id.map(element => element.id).join(',')
        }else {
          ids = id
        }
        let params = {
          ids: ids
        }
        this.$http.post('/registration/summit', params).then(res => {
          if (res.data.success && res.status == 200) {
            this.$message({
              message: "提交成功",
              type: "success",
            })
            this.getPageList()
          }else {
            this.$message({
              message: res.data.msg,
              type: "error",
            })
          }
        })
      })
    },
    deleteItem: function(id) {
      if(Array.isArray(id) || !id.length){
        if (id.some(item => item.statusText !== '机构确认中' && item.statusText !== '评价方驳回')) {
          this.$message({
            message: "请选择状态为机构确认中的考生进行删除",
            type: "error",
          })
          return;
        } else if (!id.length) {
          this.$message({
            message: "请最少选择一项",
            type: "error",
          })
          return;
        }
      }
      this.$dialog.confirm({
        title: '提示',
        confirmButtonText: '确定',
        message: `确定要删除${id.length > 1 && Array.isArray(id)? id.length : '该'}条报名信息吗？`,
        confirmButtonColor:'#54B0FB'
      }).then(()=>{
        let ids = ''
        if(Array.isArray(id)){
          ids = id.map(element => element.id).join(',')
        }else {
          ids = id
        }
        let params = {
          ids: ids
        }
        this.$http.put('/registration/delete/id', params).then(res => {
          if(res.data.success){
            this.$message({
              message: "删除成功",
              type: "success",
            })
            this.getPageList()
          }else{
            this.$message({
              message: "删除失败",
              type: "error",
            })
          }
        })
      })
    },
    getExport: function(item) {
      if(!item.length){
        this.$message({
          message: "请选择数据",
          type: "error",
        })
        return
      } 
      let ids = item.map(element => element.id).join(',')
      let params = {
        ids: ids
      }
      this.$http.post('/examFile/export/getExport', params, {responseType: 'blob'}).then(res => {
        if(res.data){
          let filename=decodeURIComponent(res.headers.filename)
          downloadBlob(res.data, filename)
        }else{
          this.$message({
            message: res.data.msg,
            type: "error",
          })
        }
      })
    },
    handleSizeChange(val) {
      this.page = 1
      this.limit = val
      this.getPageList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getPageList()
    },
    studentInfoReview(id) {
      this.$router.push(`/batchSignUp/review/${id}/review`)
    },
    studentInfoPreview(id) {
      this.$router.push(`/batchSignUp/preview/${id}/preview`)
    },
    submitispay() {
      this.showdailog = false
      this.$router.push({ path: '/batchSignUp/appointment/edit' })
    },
    submitnopay() {
      this.showdailog = false
      this.showreject = false
    },
    gotoOrderDetail: function(data) {
      this.$router.push({path: `/order/pay/${data.orderId}`, query: {role: 'organization', status: data.status} })
    },
    gotoReject: function(id) {  //查看驳回原因
      let params ={
        id: id
      }
      this.$http.get('/registration/reject/reason', {params}).then(res => {
        Dialog.alert({
          title: '提示',
          message: res.data.msg,
        })
      }) 
      
    },
    handleSelectionChange(val) {  //多选方法
      this.multipleSelection = val;
    },
    getRowKeys(row) {
      return row.id;
    },
    cellStyle: function(row) {
      if(row.column.label === '状态' && row.row.statusText === "机构确认中"){
        return 'color:#E0721E'
      }
      if(row.column.label === '状态' && row.row.statusText === "评价方审核中"){
        return 'color:#54B0FB'
      }
      if(row.column.label === '状态' && row.row.statusText === "待预约"){
        return 'color:#24B726'
      }
      if(row.column.label === '状态' && row.row.statusText === "待支付"){
        return 'color:#E02020'
      }
      if(row.column.label === '状态' && row.row.statusText === "支付审核中"){
        return 'color:#54B0FB'
      }
      if(row.column.label === '状态' && row.row.statusText === "评价方驳回"){
        return 'color:#8132ED'
      }
      if(row.column.label === '状态' && row.row.statusText === "支付已驳回"){
        return 'color:#E02020'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.exam_contain {
  min-width: 1980px;
  box-sizing: border-box;
}
.exam_contain {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: @whitee;
  width: 100%;
  padding: 30px;
  overflow: auto;
  height: 100vh;
}
.exam_button_box {
  display: flex;
  justify-content: flex-end;
  margin: 40px 0;
}
.exam_button_box button {
  width: 200px;
  height: 80px;
  margin: 0 20px 0 0;
}
.page_footer{
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  .van-pagination{
    margin: 0 20px;
  }
}
.operation_img {
  width: 25PX !important;
  height: 25PX !important;
  display: block;
  margin: 0 3PX
}
.exam_select_flex {
  display: flex;
  flex-direction: column;
  margin-left: 40PX;
}
.exam_select_box{
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-top: 50px;
}
.exam_select_item{
  white-space: nowrap;
  display: flex;
  align-items: center;
  margin-right: 50px;
}
.table_wrapper {
  flex: 1;
  width: 100%;
  margin: 0;
  height: 650PX;
  position: relative;
  .table_content {
    position: absolute;
    width: 100%;
    margin: 0;
    .table_content_operation{
      display: flex;
      justify-content: center;
    }
  }
}
::v-deep .has-gutter{
  color: black;
}
::v-deep .cell {
  text-align: center;
  padding: 0 10px !important;
}
::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell{
  background: #F0F5FA;
}
</style> 
